module.exports={
  "ray-mcguire": {
    "name": "Ray McGuire",
    "lastName": "McGuire",
    "label": "RM",
    "image": "ray_mcguire.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "eric-adams": {
    "name": "Eric Adams",
    "lastName": "Adams",
    "label": "EA",
    "image": "eric_adams.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "curtis-sliwa": {
    "name": "Curtis Sliwa",
    "lastName": "Sliwa",
    "label": "CS",
    "image": "curtis_sliwa.png",
    "party": "R",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "maya-wiley": {
    "name": "Maya Wiley",
    "lastName": "Wiley",
    "label": "MW",
    "image": "maya_wiley.png",
    "party": "D",
    "pronoun": "she",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "andrew-yang": {
    "name": "Andrew Yang",
    "lastName": "Yang",
    "label": "AY",
    "image": "andrew_yang.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "kathryn-garcia": {
    "name": "Kathryn Garcia",
    "lastName": "Garcia",
    "label": "KG",
    "image": "kathryn_garcia.png",
    "party": "D",
    "pronoun": "she",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "dianne-morales": {
    "name": "Dianne Morales",
    "lastName": "Morales",
    "label": "DM",
    "image": "dianne_morales.png",
    "party": "D",
    "pronoun": "she",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "shaun-donovan": {
    "name": "Shaun Donovan",
    "lastName": "Donovan",
    "label": "SD",
    "image": "shaun_donovan.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "scott-stringer": {
    "name": "Scott Stringer",
    "lastName": "Stringer",
    "label": "SS",
    "image": "scott_stringer.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "fernando-mateo": {
    "name": "Fernando Mateo",
    "lastName": "Mateo",
    "label": "FM",
    "image": "fernando_mateo.png",
    "party": "R",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "aaron-foldenauer": {
    "name": "Aaron Foldenauer",
    "lastName": "Foldenauer",
    "label": "AF",
    "image": "aaron_foldenauer.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "art-chang": {
    "name": "Art Chang",
    "lastName": "Chang",
    "label": "AC",
    "image": "art_chang.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "isaac-wright": {
    "name": "Isaac Wright Jr.",
    "lastName": "Wright Jr.",
    "label": "IW",
    "image": "isaac_wright.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "paperboy-prince": {
    "name": "Paperboy Prince",
    "lastName": "Prince",
    "label": "PP",
    "image": "paperboy_prince.png",
    "party": "D",
    "pronoun": "they",
    "droppedOut": "",
    "droppedOutDate": ""
  },
  "joycelyn-taylor": {
    "name": "Joycelyn Taylor",
    "lastName": "Taylor",
    "label": "JT",
    "image": "joycelyn_taylor.png",
    "party": "D",
    "pronoun": "she",
    "droppedOut": "",
    "droppedOutDate": ""
  }
}